import { render, staticRenderFns } from "./award-winning-builders.vue?vue&type=template&id=7567d216&scoped=true&"
import script from "./award-winning-builders.vue?vue&type=script&lang=js&"
export * from "./award-winning-builders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567d216",
  null
  
)

export default component.exports